let originalBodyPaddingRight;
let originalBodyOverflow;

const _getScrollbarWidth = () => {
    const parent = document.createElement('div');
    const child = document.createElement('div');

    parent.style.cssText =
        'width:50px; height:50px; overflow:auto; position: absolute; top: 10px; left: -1000px;';

    parent.appendChild(child);
    document.body.appendChild(parent);

    const childWidth = child.offsetWidth;
    child.style.height = '99px';

    const scrollbarWidth = childWidth - child.offsetWidth;

    document.body.removeChild(parent);

    return scrollbarWidth;
};

const scrollbarWidth = _getScrollbarWidth();

const showScroll = () => {
    document.body.style.paddingRight = originalBodyPaddingRight;
    document.body.style.overflow = originalBodyOverflow;
};

const _setPopupOverflow = () => {
    if (window.innerHeight < document.documentElement.scrollHeight) {
        setTimeout(() => {
            const modal = document.querySelector('.ui.page.modals.dimmer');

            if (modal) {
                modal.style.overflowY = 'scroll';
            }
        }, 0);
    }
};

const hideScroll = () => {
    if (originalBodyPaddingRight === undefined) {
        originalBodyPaddingRight = document.body.style.paddingRight;
    }

    if (originalBodyOverflow === undefined) {
        originalBodyOverflow = document.body.style.overflow;
    }

    _setPopupOverflow();

    document.body.style.paddingRight = `${scrollbarWidth}px`;
    document.body.style.overflow = 'hidden';
};

export const ScrollbarUtils = {
    showScroll,
    hideScroll,
};
